<template>
  <button
    v-if="selectedItemsTitles.length === 0"
    class="tw-group tw-flex tw-h-8 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-px-3 tw-py-2.5 tw-pr-2.5 tw-text-xs tw-font-medium hover:tw-border-transparent hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-border-slate-200 disabled:tw-bg-slate-50 disabled:tw-text-slate-400"
    type="button"
    :disabled="disabled"
    data-testid="multiselect-trigger-button"
    @click="handleOpenClick"
  >
    {{ buttonText }}
    <TablerChevronDown class="tw-ml-1 tw-h-3 tw-w-3 tw-text-slate-500 group-hover:tw-text-deep-orange-400" />
  </button>
  <div v-else class="tw-flex tw-items-center">
    <button
      class="tw-flex tw-h-8 tw-items-center tw-justify-center tw-rounded-l-lg tw-bg-deep-orange-50 tw-pl-3 tw-pr-1.5 tw-text-xs tw-font-medium tw-text-deep-orange hover:tw-bg-deep-orange-100 focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-border-slate-200 disabled:tw-bg-slate-50 disabled:tw-text-slate-400"
      type="button"
      :disabled="disabled"
      data-testid="multiselect-trigger-button"
      @click="handleOpenClick"
    >
      <span class="tw-line-clamp-1">{{ buttonText }}</span>
    </button>
    <button
      class="tw-h-8 tw-rounded-r-lg tw-bg-deep-orange-50 tw-px-1.5 tw-text-deep-orange hover:tw-bg-deep-orange-100 disabled:tw-cursor-not-allowed disabled:tw-border-slate-200 disabled:tw-bg-slate-50 disabled:tw-text-slate-400"
      data-testid="multiselect-trigger-clear-button"
      type="button"
      :disabled="disabled"
      @click="handleClearClick"
    >
      <TablerX class="tw-h-3.5 tw-w-3.5" />
    </button>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import TablerChevronDown from './Icons/tabler/TablerChevronDown.vue';
import TablerX from './Icons/tabler/TablerX.vue';

import analytics from '@/analytics';

export default defineComponent({
  name: 'StudioMultiselectTriggerButton',
  components: { TablerX, TablerChevronDown },
  props: {
    selectedItemsTitles: {
      type: Array as () => string[],
      required: true
    },
    suffix: {
      type: Object as PropType<{ singular: string; plural: string }>,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    characterLengthThreshold: {
      type: Number,
      default: 60
    }
  },
  computed: {
    buttonText(): string {
      const count = this.selectedItemsTitles.length;

      if (count === 0) {
        return `${this.suffix.plural}`;
      }

      const joinedTitlesString = this.selectedItemsTitles.join(', ');
      if (joinedTitlesString.length <= this.characterLengthThreshold) {
        return joinedTitlesString;
      }

      if (count === 1) {
        return `1 ${this.suffix.singular}`;
      }

      return `${count} ${this.suffix.plural}`;
    }
  },
  methods: {
    handleOpenClick(): void {
      analytics.track('studio_multiselect_trigger_button_clicked');
      this.$emit('open');
    },
    handleClearClick(): void {
      analytics.track('studio_multiselect_trigger_button_clear_clicked');
      this.$emit('clear');
    }
  }
});
</script>
